<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ziypni/tc-custom/9781504045513.jpg?1734279933425" alt="This image is the cover for the book Kent Family Chronicles Volumes One Through Three, The Kent Family Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kent Family Chronicles Volumes One Through Three, The Kent Family Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>The first three novels in a sweeping American epic from the #1 <i>New York Times</i>–bestselling author who “makes history come alive” (Nelson DeMille).</b><br/><br/> This multigenerational saga follows the Kent family and their pursuit of a foothold and future in the expanding United States. From the family’s initial journey traveling to America’s shore to their voyage to the Western frontier, their fate is intertwined with the course of American history in these first three volumes of the series.<br/>  <br/><i>The Bastard</i>: Denied his birthright as the illegitimate son of the Duke of Kentland, Philippe Charboneau seeks a new life in London, where he meets Benjamin Franklin and reads the works of patriot firebrand Sam Adams. Inspired by such brave new ideas, he travels to the American colonies at the brink of the Revolution. There he will choose his own name—Philip Kent—and finally decide his own fate.<br/>  <br/><i>The Rebels</i>: Philip Kent fights as a Continental soldier at the Battle of Bunker Hill. In a bold move, he has taken up arms for the future of his new family. Spirited and unwavering in his dedication to his adopted homeland, Philip fights in the most violent battles in America’s early history. But far from the front lines, another battle rages that will sweep his wife, Anne, on her own perilous journey that may destroy all Philip has fought for.<br/>  <br/><i>The Seekers</i>: Returning from fighting valiantly on the frontier, Abraham Kent—son of Philip and Anne—returns to Boston, only to realize that he cannot abide the confines of civilization. Determined not to live in his father’s shadow, he takes his young bride and settles on the American frontier. But the life of a pioneer comes at a high price, and the cost of Abraham’s restless ambitions may be more than he can bear.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Jakes
      </h2>
      
      <p class="authorDescription body article">John Jakes (b. 1932), the author of more than a dozen novels, is regarded as one of today&rsquo;s most distinguished writers of historical fiction. His work includes the highly acclaimed Kent Family Chronicles series and the North and South Trilogy. Jakes&rsquo;s commitment to historical accuracy and evocative storytelling earned him the title of &ldquo;the godfather of historical novelists&rdquo; from the <I>Los Angeles Times</I> and led to a streak of sixteen consecutive <I>New York Times</I> bestsellers. Jakes has received several awards for his work and is a member of the Authors Guild and the PEN American Center. He and his wife, Rachel, live on the west coast of Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f717ab5